function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("tab-active"); // Remove "active" class from all tabs
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.classList.add("tab-active"); // Add "active" class to the clicked tab
}

function openPanel(tabName) {
  var sidePanel = document.getElementById("sidePanel");
  sidePanel.classList.add("active");
  document.getElementById("backdrop").style.display = "block";
  openTab(event, tabName);

// Manually add the "tab-active" class to the specified tab
  var tabButton = document.querySelector(`button[data-tab="${tabName}"]`);
  tabButton.classList.add("tab-active");

  
}

function closePanel() {
  var sidePanel = document.getElementById("sidePanel");
  sidePanel.classList.remove("active");
  document.getElementById("backdrop").style.display = "none";
}

document.getElementById("openPanel1").addEventListener("click", function() {
  openPanel('tab1');
});

document.getElementById("openPanel2").addEventListener("click", function() {
  openPanel('tab2');
});

